import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListMultiple = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 34 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.7998 10.5479C13.7998 9.99563 14.2475 9.54791 14.7998 9.54791H31.9998C32.5521 9.54791 32.9998 9.99563 32.9998 10.5479V32.0146C32.9998 32.5669 32.5521 33.0146 31.9998 33.0146H14.7998C14.2475 33.0146 13.7998 32.5669 13.7998 32.0146V10.5479Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7999 28.7479H9.53324C8.35503 28.7479 7.3999 27.7928 7.3999 26.6146V7.41458C7.3999 6.23638 8.35503 5.28125 9.53324 5.28125H24.4666C25.6448 5.28125 26.5999 6.23638 26.5999 7.41458V9.54792",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.4 24.4803H3.13333C1.95513 24.4803 1 23.5252 1 22.347V3.14701C1 1.9688 1.95513 1.01367 3.13333 1.01367H18.0667C19.2449 1.01367 20.2 1.9688 20.2 3.14701V5.28034",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4668 14.8812H28.7335",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0669 14.8812L19.1336 15.9479L21.2669 13.8146",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4668 21.2812H28.7335",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0669 21.2813L19.1336 22.3479L21.2669 20.2146",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4668 27.6813H28.7335",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0669 27.6813L19.1336 28.7479L21.2669 26.6146",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgListMultiple);
export default ForwardRef;
